module.exports = {"id":"175943","name":"Dries Mertens","rating":"87","photo":"./data/images/photos/3/175943.png","club":{"name":"Naples","logo":"./data/images/clubs/Naples.png"},"positions":["ATT","AG","BU"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DriesMertens0.json
// module id = 1151
// module chunks = 0